import React from "react";
import { Form, Select } from "antd";
import Icons from "components/icons";
import { Localize } from "components/service";


const LanguageStatusSelect = ({
    disabled = false,
    name = 'status',
    label = <Localize>FORMS.Input_Label_Status</Localize>
}) => (
    <Form.Item
        name={ name }
        label={ label }
        rules={ [
            {
                validator: (_, value) => (
                    typeof value === 'boolean' ?
                        Promise.resolve() :
                        Promise.reject(Localize({ children: "FORM_RULES.Required_Choose" }).props.children)
                )
            }
        ] }
    >
        <Select
            suffixIcon={ <Icons.Arrow /> }
            className="select-serch-input"
            disabled={ disabled }
            dropdownClassName="select-serch-dropdown"
        >
            <Select.Option value={ true }>
                <Localize>GLOBAL.Text_Status_Active</Localize>
            </Select.Option>
            <Select.Option value={ false }>
                <Localize>GLOBAL.Text_Status_Disabled</Localize>
            </Select.Option>
        </Select>
    </Form.Item>
);

export default LanguageStatusSelect;
